import { api } from "../../../api/api";
import { appConfig } from "../../../config/runtime-config";

const host = appConfig.tagsUrl;
const basePath = appConfig.apiBasePath;
const resource = "tags";
const url = `${host}/${basePath}/${resource}`;

/** @param {Record<string, any>} [filters] @returns {Promise<ServiceTag[]>} */
export const getServicesTags = (filters) =>
  api.get(`${url}/services`, { ...filters }).then((res) => res.data);

/** @param {string} serviceName @param {string[]} tags @returns {Promise<ServiceTag>} */
export const createServiceTag = (serviceName, tags = []) =>
  api
    .post(`${url}/services/${serviceName}`, {
      tags,
    })
    .then((res) => res.data);

/** @param {string} query @returns {Promise<string[]>} */
export const searchTags = (query) =>
  api.get(`${url}/search`, { query }).then((res) => res.data);
